import { render, staticRenderFns } from "./PublicReservation1.vue?vue&type=template&id=0974c116&scoped=true&"
import script from "./PublicReservation1.vue?vue&type=script&lang=js&"
export * from "./PublicReservation1.vue?vue&type=script&lang=js&"
import style0 from "./PublicReservation1.vue?vue&type=style&index=0&id=0974c116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974c116",
  null
  
)

export default component.exports